import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import ImageUpload from '../../../Components/common/ImageUpload';
import ActivityComments from '../../../Components/common/ActivityComments';
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Badge, Modal, Tab, Tabs, Stack, Button, Form, Accordion, ModalTitle } from 'react-bootstrap';
import { faPlus, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Docmnt from '../../../assets/images/google-docs.png';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import edit from "../../../assets/images/edit.png";
import Nonedit from "../../../assets/images/management.png";
import EditIcon from "../../../assets/images/view.png";
import view from "../../../assets/images/chat.png";
import MailGreen from '../../../assets/images/mail_green.png';
import MailRed from '../../../assets/images/mail_red.png';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MOVETOACTARC, RECOVERYARCACT, RECOVERYDETAILS, STATIONLIST, STATIONHANDLER, GETOWNERCODE, SAVEHANDLER, SAVERECOVERY } from '../../../Utils/conts.js';
// import AddRecovery from './AddRecovery';
import { toast } from 'react-toastify';
import Trash from '../../../assets/images/trash.png';
import Export from "../../../assets/images/export.svg";
import { MultiSelect } from 'react-multi-select-component';
import AddRecovery from './common/AddRecovery.js';
import DownloadGrid from './common/DownloadGrid.js';
import arroow from '../../../assets/images/arroow.png';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const ServiceRecovery = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        Damaged: [],
    });
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [allDropdown, setAllDropdown] = useState([]);
    const [activeTab, setActiveTab] = useState('Active');
    const [filterApplied, setFilterApplied] = useState(false);
    const [dayCount, setDayCount] = useState({});
    const [dayNumber, setDayNumber] = useState(0);

    const [formData, setFormData] = useState({ all_stations: [], origin_notify_status: 1, destination_notify_status: 1 });

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
        Damaged: useRef(null),
    };


    useEffect(() => {
        if (isMounted.current) return;
        fetchDropdown(0);
        // setIsLoading(false);
        // setGridData({ Active: {} });
        // fetchDataGridR();
        isMounted.current = true;
    }, []);

    const fetchDropdown = async (num) => {
        try {

            const res = await withRFSToken.post('service-recovery/dropdown-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // setCommodityType(innerData.commodity_type);
                    // setMovementType(innerData.movement_type);
                    setAllDropdown(innerData);
                    // setRecoveryInfo(innerData.recovery_information);
                    setIsLoading(false);
                    setGridData({ Active: {} });
                    if (num !== 0) { setFilterApplied(true); } else { setFilterApplied(false); }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        } else if (tab == 'Archived') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Damaged: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ASR;
            jqxCookieCall();

            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'service_recovery_id', type: 'string' },
                    { name: 'master_airway_bill', type: 'string' },
                    { name: 'created_date', type: 'string' },
                    // { name: 'status', type: 'string' },
                    { name: 'total_mawb_pieces', type: 'string' },
                    { name: 'total_traced_pieces', type: 'string' },
                    { name: 'total_mawb_wght', type: 'string' },
                    { name: 'pieces_involved', type: 'string' },
                    { name: 'pieces_wght', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                    { name: 'recovery_aspects_text', type: 'string' },
                    { name: 'created_by', type: 'string' },
                    { name: 'recovery_status', type: 'string' },
                    { name: 'last_activity', type: 'string' },
                    { name: 'last_message', type: 'string' },
                    { name: 'new_message', type: 'string' },
                    { name: 'age', type: 'string' },
                    // { name: 'case_status', type: 'string' },
                    // { name: 'priority_level', type: 'string' },
                    // { name: 'action_status', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'case_status_name', type: 'string' },
                    { name: 'sub_status_name', type: 'string' },
                    { name: 'action_status', type: 'string' },
                    { name: 'priority_level', type: 'string' },
                    { name: 'recovery_aspects', type: 'string' },
                    { name: 'sub_status_image_url', type: 'string' },
                    { name: 'origin_email', type: 'string' },
                    { name: 'destination_email', type: 'string' },
                    { name: 'update_on', type: 'string' },
                    { name: 'isEditable', type: 'string' },
                    { name: 'reported', type: 'string' },
                    { name: 'reported_email', type: 'string' },
                    { name: 'origin_recovery_status', type: 'boolean' },
                    { name: 'destination_recovery_status', type: 'boolean' },
                    { name: 'reported_recovery_status', type: 'boolean' },
                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}service-recovery/list?recovery_type=${activeTab}&day_count=${dayNumber}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {

                    source.totalrecords = data.TotalRows;

                    if (!data?.Rows || data.Rows.length === 0 || data.response_code === 400) {
                        columns[0].cellsrenderer = () => "";
                        columns[4].cellsrenderer = () => "";
                        columns[12].cellsrenderer = () => "";
                        columns[14].cellsrenderer = () => "";
                    }
                    setDayCount(data.count)
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        let editable = '<div class="grid_actions">';
                        if (rowdata.isEditable) {
                            editable += '<div><img src="' + edit + '" class="row_edit" /></div>';
                        } else {
                            editable += '<div><img src="' + EditIcon + '" class="row_edit" /></div>'; //Nonedit
                        }
                        if (rowdata.new_message === 0) {
                            editable += '<div><img src="' + view + '" class="row_msg" /></div></div>';
                            // return '<div class="grid_actions"><div><img src="' + edit + '" class="row_edit" /></div> ';
                        } else {
                            editable += '<div class="update_msg"><img src="' + view + '" class="row_msg" /><span class="new_msg"></span></div></div>';
                            // return '<div class="grid_actions"><div><img src="' + edit + '" class="row_edit" /></div> <div class="update_msg"><img src="' + view + '" class="row_update" /><span class="new_msg"></span></div></div>';
                        }
                        return editable;
                        // if (rowdata.new_message === 0) {
                        //     return '<div class="grid_actions"><div><img src="' + edit + '" class="row_edit" /></div><div><img src="' + view + '" class="row_msg" /></div></div>'; // <div><img src="' + view + '" class="row_update" /></div>
                        // } else {
                        //     return '<div class="grid_actions"><div><img src="' + edit + '" class="row_edit" /></div> <div class="update_msg"><img src="' + view + '" class="row_msg" /><span class="new_msg"></span></div></div>'; // <div class="update_msg"><img src="' + view + '" class="row_update" /><div>
                        // }
                    },
                    width: '5%', filterable: false,
                },
                { text: 'AWB No', filtertype: 'textbox', datafield: 'master_airway_bill', width: '7%', cellclassname: '', },
                // { text: 'Created Date', filtertype: 'textbox', datafield: 'created_date', width: '7%', cellclassname: '', },
                { text: 'Age', filtertype: 'textbox', datafield: 'age', width: '5%', cellclassname: '', },
                { text: 'Flight', filtertype: 'textbox', datafield: 'flight_number', width: '6%', cellclassname: '', },
                // { text: 'Find Pieces', filtertype: 'textbox', datafield: 'find_pieces', width: '5%', cellclassname: '', },

                {
                    text: 'Case Status', filtertype: 'checkedlist', datafield: 'case_status_name', width: '8%', cellclassname: '',
                    filteritems: [
                        { label: 'New', value: '19' },
                        { label: 'Viewed', value: '156' },
                        { label: 'In Progress', value: '20' },
                        { label: 'Closed', value: '21' },
                    ],
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log(rowdata);
                        if (rowdata.case_status_name === 'New') {
                            return '<div class="jqx-grid-cell-left-align serv_new" "> ' + value + ' </div>';
                        } else if (rowdata.case_status_name === 'In Progress') {
                            return '<div class="jqx-grid-cell-left-align serv_progress" >' + value + '</div>';
                        } else if (rowdata.case_status_name === 'Closed') {
                            return '<div class="jqx-grid-cell-left-align serv_closed" >' + value + ' </div>';
                        } else if (rowdata.case_status_name === 'Viewed') {
                            return '<div class="jqx-grid-cell-left-align serv_viewed" >' + value + ' </div>';
                        }
                    },
                },
                {
                    text: 'Sub Status', datafield: 'sub_status_name', width: '10%', cellclassname: '', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'New', value: '137' },
                        { label: 'Processing', value: '138' },
                        { label: 'Monitoring', value: '139' },
                        { label: 'End Tracing', value: '140' },
                        { label: 'Customs Declared', value: '141' },
                        { label: 'Non Discharged', value: '142' },
                        { label: 'Pre Collection', value: '143' },
                        { label: 'Final Collection', value: '144' },
                        { label: 'Reviewing', value: '145' },
                        { label: 'Legal proceedin', value: '146' },
                        // { label: 'Resolved', value: '147' },
                    ],
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log(rowdata);
                        if (rowdata.sub_status_image_url && value) {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + rowdata.sub_status_image_url + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align">' + value + '</div>';
                        }
                    },
                },
                {
                    text: 'Priority Level', filtertype: 'checkedlist', datafield: 'priority_level', width: '8%', cellclassname: '',
                    filteritems: [
                        { label: 'Low', value: '134' },
                        { label: 'Medium', value: '135' },
                        { label: 'High', value: '136' },
                    ],
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log(rowdata);
                        if (rowdata.priority_level === 'Low') {
                            return '<div class="low_serv"> ' + value + ' </div>';
                        } else if (rowdata.priority_level === 'Medium') {
                            return '<div class="medium_serv">' + value + '</div>';
                        } else if (rowdata.priority_level === 'High') {
                            return '<div class="critical_serv">' + value + ' </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;" >' + value + ' </div>';
                        }
                    },
                },
                // { text: 'Action Status', filtertype: 'textbox', datafield: 'action_status', width: '7%', cellclassname: '', },

                {
                    text: 'Recovery Aspects', filtertype: 'checkedlist', datafield: 'recovery_aspects', width: '10%', cellclassname: '',
                    // filteritems: [
                    //     { value: 113, label: "MSCA" },
                    //     { value: 114, label: "FDCA" },
                    //     { value: 115, label: "MSAW" },
                    //     { value: 116, label: "FDAW" },
                    //     { value: 117, label: "SSPD" },
                    //     { value: 118, label: "OVCD" },
                    //     { value: 119, label: "OFLD" },
                    //     { value: 120, label: "UNLABELED" },
                    //     { value: 121, label: "REFUSED" },
                    //     { value: 122, label: "BLOCKED" },
                    //     { value: 123, label: "OLD SHPMNT" },
                    //     { value: 124, label: "RTO 90 days inquiry" },
                    //     { value: 125, label: "MSDOCS" },
                    //     { value: 126, label: "OTHER" },
                    //     { value: 133, label: "DMA" }
                    // ],
                    filteritems: allDropdown.recovery_aspects
                },
                // { text: 'Pieces', filtertype: 'textbox', datafield: 'total_mawb_pieces', width: '5%', cellclassname: '', },
                // { text: 'Weight', filtertype: 'textbox', datafield: 'total_mawb_wght', width: '5%', cellclassname: '', },


                { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces_involved', width: '6%', cellclassname: '', },
                { text: 'Weight', filtertype: 'textbox', datafield: 'pieces_wght', width: '6%', cellclassname: '', },
                {
                    text: 'Traced', filtertype: 'textbox', datafield: 'total_traced_pieces', width: '5%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log('fffffffff', rowdata.recovery_aspects);
                        const allowed = ['MSCA'];
                        const hasMatch = rowdata.recovery_aspects?.some(aspect => allowed.includes(aspect));

                        if (hasMatch) {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + value + '</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> N/A </div>';
                        }
                    },
                },
                { text: 'Flight Date', filtertype: 'textbox', datafield: 'flight_date', width: '6%', cellclassname: '', },
                {
                    text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '5%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        const hasEmail = rowdata.origin_email && rowdata.origin_email !== '';
                        const hasRecovery = rowdata.origin_recovery_status == true;
                        const mailIcon = hasEmail ? MailGreen : MailRed;
                        let ors = hasRecovery
                            ? '<span class="rs_green"></span>'
                            : '<span class="rs_red"></span>';

                        return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;"><img src="${mailIcon}" style="width:18px; height:18px; margin-right:10px;" />${value}${ors}</div>`;
                        // console.log(rowdata);
                        // if (rowdata.origin_email === null || rowdata.origin_email === '') {
                        //     return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailRed + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                        // } else {
                        //     return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailGreen + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                        // }
                    },
                },
                {
                    text: 'Reported', filtertype: 'textbox', datafield: 'reported', width: '6%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log(rowdata);
                        if (value) {
                            const hasEmail = rowdata.reported_email && rowdata.reported_email !== '';
                            const hasRecovery = rowdata.reported_recovery_status == true;
                            const mailIcon = hasEmail ? MailGreen : MailRed;
                            let rrs = hasRecovery
                                ? '<span class="rs_green"></span>'
                                : '<span class="rs_red"></span>';

                            return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;"><img src="${mailIcon}" style="width:18px; height:18px; margin-right:10px;" />${value}${rrs}</div>`;
                            // if (rowdata.reported_email === null || rowdata.reported_email === '') {
                            //     return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailRed + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                            // } else {
                            //     return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailGreen + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                            // }
                        } else { return '' }
                    },
                },
                {
                    text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '5%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        const hasEmail = rowdata.destination_email && rowdata.destination_email !== '';
                        const hasRecovery = rowdata.destination_recovery_status == true;
                        const mailIcon = hasEmail ? MailGreen : MailRed;
                        console.log('rowdata.destination_recovery_status', rowdata.destination_recovery_status);

                        let drs = hasRecovery
                            ? '<span class="rs_green"></span>'
                            : '<span class="rs_red"></span>';

                        console.log('drs', drs);
                        return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;"><img src="${mailIcon}" style="width:18px; height:18px; margin-right:10px;" />${value}${drs}</div>`;
                        // console.log(rowdata);
                        // if (rowdata.destination_email === null || rowdata.destination_email === '') {
                        //     return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailRed + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                        // } else {
                        //     return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailGreen + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                        // }
                    },
                },
                { text: 'Update On', filtertype: 'textbox', datafield: 'update_on', width: '6%', cellclassname: '', },

                // { text: 'Aspects', filtertype: 'textbox', datafield: 'recovery_aspects_text', width: '8%', cellclassname: '', },
                // { text: 'Last Activity', filtertype: 'textbox', datafield: 'last_activity', width: '10%', cellclassname: '', },

                // { text: 'Created By', filtertype: 'textbox', datafield: 'created_by', width: '8%', cellclassname: '', },
                // { text: 'Last Message By', filtertype: 'textbox', datafield: 'last_message', width: '13%', cellclassname: '', },
            ];
            const nestedColumns = [
                { text: 'Station', datafield: 'station_name', width: '5%' },
                { text: 'Type', datafield: 'handler_type', width: '6%' },
                { text: 'Handler Name', datafield: 'handler_name', width: '10%' },
                // { text: 'Handler Action', datafield: 'handler_action', width: '8%' },
                // {
                //     text: 'Status', datafield: 'status', width: '10%',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         // console.log(rowdata);
                //         if (rowdata.status === 'Open') {
                //             return '<div class="open"> ' + value + ' </div>';
                //         } else if (rowdata.status === 'Traced') {
                //             return '<div class="traced">' + value + '</div>';
                //         } else if (rowdata.status === 'Progress') {
                //             return '<div class="reco_progress">' + value + ' </div>';
                //         } else if (rowdata.status === 'Closed') {
                //             return '<div class="closes">' + value + ' </div>';
                //         } else {
                //             return '<div class="">' + value + ' </div>';
                //         }
                //     },
                // },
                {
                    text: 'Sub Status', filtertype: 'textbox', datafield: 'sub_status', width: '9%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log(rowdata);
                        if (rowdata.sub_status_image_url && value) {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + rowdata.sub_status_image_url + ' style="width:18px; height:18px;margin-right:10px;"/>' + value + ' </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> ' + value + '</div>';
                        }
                    },
                },
                {
                    text: 'Case Status', datafield: 'case_status', width: '10%',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log(rowdata);
                        if (rowdata.case_status === 'New') {
                            return '<div class="jqx-grid-cell-left-align serv_new" "> ' + value + ' </div>';
                        } else if (rowdata.case_status === 'In Progress') {
                            return '<div class="jqx-grid-cell-left-align serv_progress" >' + value + '</div>';
                        } else if (rowdata.case_status === 'Closed') {
                            return '<div class="jqx-grid-cell-left-align serv_closed" >' + value + ' </div>';
                        } else if (rowdata.case_status === 'Viewed') {
                            return '<div class="jqx-grid-cell-left-align serv_viewed" >' + value + ' </div>';
                        }
                    },
                },
                // {
                //     text: 'Update Recovery', width: '9%', filterable: false,
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         if (rowdata.isEditable) {
                //             return '<div class="update_rv"><div class="row_update update_rec_btn">Update</div>';
                //         }
                //     },
                // },
                { text: 'Pieces Traced', datafield: 'pieces_traced', width: '10%' },
                { text: 'Tracing Date', datafield: 'tracing_date', width: '10%' },
                {
                    text: 'Email Id', datafield: 'handler_email', width: '15%',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.handler_email === null || rowdata.handler_email === '') {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailRed + ' style="width:18px; height:18px;margin-right:10px;"/> </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> <img src=' + MailGreen + ' style="width:18px; height:18px;margin-right:10px;"/> </div>';
                        }
                    },
                },
                // {
                //     text: 'Report Status', datafield: '', width: '10%',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         // console.log(rowdata);
                //         if (rowdata.recovery_status === 'Closed') {
                //             return '<div class="closes"> Closed </div>';
                //         } else {
                //             return '<div class="update_rv"><div class="update_rec_btn"> Active </div></div>';
                //         }
                //     },
                // },
            ];

            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                // console.log(dataAdapter);
                const id = record.uid.toString();
                const uldGrid = dataAdapter?.loadedData?.Rows[id]?.all_stations || [];

                const nestedSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'station_name', type: 'string' },
                        { name: 'handler_name', type: 'string' },
                        { name: 'handler_type', type: 'string' },
                        { name: 'recovery_status', type: 'string' },
                        { name: 'case_status', type: 'string' },
                        { name: 'handler_email', type: 'string' },
                        { name: 'pieces_traced', type: 'string' },
                        { name: 'tracing_date', type: 'string' },
                        { name: 'sub_status', type: 'string' },
                        { name: 'status', type: 'string' },
                        { name: 'isEditable', type: 'string' },
                        { name: 'sub_status_image_url', type: 'string' },
                    ],
                    localdata: uldGrid,
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '90%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: true,
                    height: (10 * 45),
                    selectionmode: 'none',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);

                window.$(nestedGridContainer).off("click").on("click", ".row_update", function () {
                    const rowDiv = window.$(this).closest('[role="row"]');
                    const rowIndex = window.$(rowDiv).attr('row-id');
                    const rowData = window.$(nestedGridContainer).jqxGrid('getrowdata', rowIndex);
                    console.log('rowData:', rowData);

                    if (rowData) {
                        // const parentRow = record;
                        const sendData = { id: record.service_recovery_id, stn: rowData.station_name }
                        // console.log('sendData', sendData);
                        localStorage.setItem('RecoveryUpdate', JSON.stringify(sendData));
                        localStorage.setItem('BackRecoveryUpdate', '/ServiceRecovery');
                        window.location.href = '/UpdateRecoveryCase';
                    } else {
                        console.error('No data found for the given row index.');
                    }
                });
            };
            // console.log('dataAdapter', dataAdapter);

            // const checkApiData = dataAdapter.totalrecords > 0 ? false : true;
            // console.log('checkApiData', dataAdapter.totalrecords);

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                // loadDetails('E', rowData.service_recovery_id);
                localStorage.removeItem('RecoveryEdit');
                localStorage.removeItem('ODTab');
                localStorage.setItem('RecoveryEdit', JSON.stringify(rowData));
                const fnPageUrl = '/OverviewDetails';
                window.location.href = fnPageUrl;
            });
            // window.$(gridRefs[activeTab].current).on('click', '.row_update', function (event) {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
            //     // loadDetails('U', rowData.service_recovery_id);
            //     localStorage.setItem('RecoveryUpdate', JSON.stringify(rowData.service_recovery_id));
            //     localStorage.setItem('BackRecoveryUpdate', '/ServiceRecovery');
            //     window.location.href = '/UpdateRecoveryCase';
            // });
            window.$(gridRefs[activeTab].current).on('click', '.row_msg', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        // window.location.href = '/MessageRecovery';
                        const transData = { ...rowData, selb: 'msg' }
                        localStorage.removeItem('RecoveryEdit');
                        localStorage.setItem('RecoveryEdit', JSON.stringify(transData));
                        const fnPageUrl = '/OverviewDetails';
                        window.location.href = fnPageUrl;
                        // loadDetails('M', rowData.service_recovery_id);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.service_recovery_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.service_recovery_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.service_recovery_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.service_recovery_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.service_recovery_id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 2) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    loadDetails('D', args.service_recovery_id);
                }
            });
        }
    }, [gridData]);

    const loadDetails = async (edt, uldNumber) => {
        try {
            const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (edt === 'E') {
                        localStorage.removeItem('RecoveryEdit');
                        localStorage.setItem('RecoveryEdit', JSON.stringify(innerData));
                        const fnPageUrl = '/OverviewDetails';
                        window.location.href = fnPageUrl;
                    } else if (edt === 'M') {
                        const transData = { ...innerData, selb: 'msg' }
                        localStorage.removeItem('RecoveryEdit');
                        localStorage.setItem('RecoveryEdit', JSON.stringify(transData));
                        const fnPageUrl = '/OverviewDetails';
                        window.location.href = fnPageUrl;
                    } else if (edt === 'U') {
                        localStorage.removeItem('RecoveryUpdate');
                        localStorage.setItem('RecoveryUpdate', JSON.stringify(innerData));
                        const fnPageUrl = '/UpdateRecovery';
                        window.location.href = fnPageUrl;
                    } else {
                        setSelectedRowData(innerData);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const dayFilter = (num) => {
        setDayNumber(num)
        setIsLoading(true);
        fetchDropdown(num)
    }

    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    // upload forward
    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    // const handleBrowseFiles = (e) => {
    //     e.preventDefault();
    //     fileInputRef.current.click();
    // };

    const [actArcModal, setActArcModal] = useState(false);
    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' || activeTab === 'Damaged' ? 'R' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.service_recovery_id)
        try {
            const res = await withRFSToken.post(RECOVERYARCACT, { service_recovery_id: uldNumbers, action: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        // fetchDataGrid()
                        // if (activeTab == 'Active') {
                        //     toast.success('ULD Data moved to Arhive');
                        //     fetchDataGrid()
                        // } else {
                        //     toast.success('ULD Data moved to Active');
                        //     fetchDataGridR()
                        // }
                        setActArcModal(false)
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleAddRecovery = () => {
        localStorage.removeItem('RecoveryEdit');
        setServiceRecoveryShow(true);


        // window.location.href = '/AddRecovery';
    }

    const resetFilters = () => {
        if (dayNumber !== 0) {
            setDayNumber(0)
            setIsLoading(true)
            fetchDropdown(0)
        } else {
            window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        }
        // gridSelect.forEach(item => {
        //     const selectedRowBoundIndex = item.boundindex;
        //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // });
        // setGridSelect([]);
    };

    const edithandler = (id) => {
        localStorage.setItem('RecoveryEdit', JSON.stringify(id));
        localStorage.setItem('EditFrom', JSON.stringify('SR'));
        const fnPageUrl = '/UpdateHandlerRecovery';
        window.location.href = fnPageUrl;
    }
    const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
    const [selectedFile, setSelectedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const [serviceRecoveryShow, setServiceRecoveryShow] = useState(false);
    const handleFileClick = (file) => {
        setSelectedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setSelectedFile("");
    };

    const closeserviceRecovery = () => {
        setServiceRecoveryShow(false);
        // setFormData({ all_stations: [], origin_notify_status: 1, destination_notify_status: 1 });
        // setOriginHandler([])
        // setDestinationHandler([])
        // setSelectedOriginHandler(null)
        // setSelectedDestinationHandler(null)
        // setFiles([])
    };

    const handleFinish = async () => {

        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
    }

    const updateRecovery = (nme) => {
        localStorage.removeItem('RecoveryUpdate');
        localStorage.removeItem('BackRecoveryUpdate');
        const sendData = { id: selectedRowData.service_recovery_id, stn: nme }
        localStorage.setItem('RecoveryUpdate', JSON.stringify(sendData));
        localStorage.setItem('BackRecoveryUpdate', '/ServiceRecovery');
        const fnPageUrl = '/UpdateRecoveryCase';
        window.location.href = fnPageUrl;
    }
    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);

    };


    return (
        <>
            {/* {console.log('recoveryAspects', recoveryAspects)} */}
            {/* <div className="">
                <Header page_type='srecovery' logo_url='/ServiceRecovery' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <div className="lcontent"> */}
            {downloadOpen && <DownloadGrid download_sec='FSM' download_tab={activeTab} onClose={closeDownloadModal} />}
            {serviceRecoveryShow && <AddRecovery onClose={closeserviceRecovery} onSubmit={handleFinish} DropData={allDropdown} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <button className="addtruck me-2" variant="primary" onClick={handleAddRecovery}>
                        <span> <FontAwesomeIcon icon={faPlus} /> Add Recovery</span>
                    </button>
                    <button className="selected" variant="link" style={{ padding: '8px 15px', background: dayNumber === 2 ? '#E7FAEF' : '' }} onClick={() => dayFilter(2)}>
                        Two Days <Badge>{dayCount?.twoDays}</Badge> <img src={arroow} alt='arroow' />
                    </button>
                    <button className="selected" variant="link" style={{ padding: '8px 15px', background: dayNumber === 5 ? '#E7FAEF' : '' }} onClick={() => dayFilter(5)}>
                        Five Days <Badge>{dayCount?.fiveDays}</Badge> <img src={arroow} alt='arroow' />
                    </button>
                    <button className="selected" variant="link" style={{ padding: '8px 15px', background: dayNumber === 10 ? '#E7FAEF' : '' }} onClick={() => dayFilter(10)}>
                        Ten Days <Badge>{dayCount?.tenDays}</Badge> <img src={arroow} alt='arroow' />
                    </button>
                    <button className="selected" variant="link" style={{ padding: '8px 15px', background: dayNumber === 20 ? '#E7FAEF' : '' }} onClick={() => dayFilter(20)}>
                        Twenty Days <Badge>{dayCount?.twentyDays}</Badge> <img src={arroow} alt='arroow' />
                    </button>
                    {/* <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action acmvt'>
                            <FontAwesomeIcon icon={faGear} /> MVT <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'UCM Out')}>UCM Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'UCM In')}>UCM In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC Out')}>LUC Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC In')}>LUC In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In')}>Repair In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair Out')}>Repair Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Lease Out')}>Lease Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'SCM')}>SCM</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                </div>
            </div>
            <div className='ulddown'>
                <button onClick={handleMoveToActArc}>
                    <img title='' src={activeTab == 'Active' || activeTab === 'Damaged' ? Arcv : Activ} />
                    {activeTab == 'Active' || activeTab === 'Damaged' ? ' Archive' : ' Active'}
                </button>
                <button onClick={showDownloadModal}><img src={Export} /> Download</button>
            </div>
            <div className="maindiv">
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span> Active Tracing </span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Damaged" title={<span> Non Tracing </span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Damaged} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived </span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3 className='reco_status'>
                                {selectedRowData.master_airway_bill_prefix} - {selectedRowData.master_airway_bill_no} &nbsp;
                                <label
                                    className={selectedRowData?.case_status_name == 'New' ? 'serv_new'
                                        : (selectedRowData?.case_status_name == 'In Progress' ? 'serv_progress'
                                            : (selectedRowData?.case_status_name == 'Closed' ? 'serv_closed' : '')
                                        )
                                    }

                                >
                                    {selectedRowData?.case_status_name}
                                </label>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>
                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>

                                <div className='viwall' onClick={() => loadDetails('E', selectedRowData.service_recovery_id)}><Link to='#'>Details</Link></div>
                            </div>
                        </div>
                        <div className='mt-3'>
                            <div className='mb-3'>
                                <h3>Highlighted Image(s)</h3>
                                {selectedRowData?.attachments && (
                                    <div className='main_primary'>
                                        {findPrimary.map((file, index) => {
                                            const fileName = file?.file_name;
                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                            const extension = fileName?.split(".").pop();
                                            return (
                                                <>
                                                    <div key={`ns_${index}`} className='primary_image'>
                                                        {["jpeg", "jpg", "png", "webp"].includes(extension)
                                                            ? (
                                                                <div>
                                                                    <img
                                                                        src={file.file_path}
                                                                        alt="Preview"
                                                                        style={{
                                                                            maxWidth: "100%",
                                                                            maxHeight: "100%",

                                                                        }}
                                                                        // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                        onClick={() =>
                                                                            handleFileClick(file.file_path)
                                                                        }
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <span className="">
                                                                        <img src={Docmnt} className="fileimg" />
                                                                    </span>
                                                                </>
                                                            )}
                                                        <span className="rafilename">
                                                            {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                                                        </span>
                                                        {/* <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                                </Link> */}

                                                        {/* {1 === 1 && ( */}
                                                        {/* {file.is_comment !== 1 &&
                                                                            file.is_editable === 1 && ( */}
                                                        {/* <button
                                                                            className="dltbtn"
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleDeleteImage(index, file.id, file.attachment_type)
                                                                            }
                                                                        >
                                                                            <FontAwesomeIcon icon={faCircleXmark} />
                                                                        </button> */}
                                                        {/* )} */}
                                                    </div>
                                                </>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                            <h3>Station Handler Information</h3>
                            {selectedRowData?.stations?.map((station, index) => (
                                <>
                                    <div className='recover_box mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>

                                            <div>
                                                <h3>{station.handler_type === 'Airline' ? 'Airline' : `${station.station_name} - ${station.handler_type}`}</h3>
                                                <span>{station.handler_name}</span>
                                            </div>

                                            <div className='text-end'>
                                                {/* <Link to="#" onClick={() => edithandler(station.handler_feedback_id)}> <FontAwesomeIcon icon={faPencil} /> Edit</Link> */}
                                                {station.isEditable && <Link to="#" onClick={() => updateRecovery(station.station_name)}> <FontAwesomeIcon icon={faPencil} /> Edit</Link>}
                                                {station.updated_by ?
                                                    <span className='d-block last_update'>Updated : {station.updated_by} </span>
                                                    :
                                                    <span className='d-block'>Not Updated</span>
                                                }
                                            </div>
                                        </div>

                                        <ul className='d-flex justify-content-between px-0'>
                                            <li>
                                                <span>Pieces Traced :</span>
                                                <span>{station.pieces_traced || ''}</span>
                                            </li>
                                            <li>
                                                <span>Tracing Date :</span>
                                                <span>{station.tracing_date || ''}</span>
                                            </li>
                                        </ul>

                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Handler Action</Accordion.Header>
                                                <Accordion.Body>
                                                    {station?.handler_action?.map((actn, index) => (
                                                        <>
                                                            {actn.warehouse_check == true &&
                                                                <div className='d-flex border_bt' key={index}>
                                                                    <div>
                                                                        <Form.Check
                                                                            inline
                                                                            type="checkbox"
                                                                            id="autoSizingCheck"
                                                                            className="me-0 mb-0"
                                                                            label={`Warehouse Check ${index + 1}`}
                                                                            checked={actn.warehouse_check}
                                                                            disabled
                                                                        />
                                                                        <Form.Label className='list_date'><FontAwesomeIcon icon={faCalendarDays} /> {actn?.warehouse_check_date || ''}</Form.Label>
                                                                    </div>
                                                                    <div>
                                                                        <Form.Check
                                                                            inline
                                                                            type="checkbox"
                                                                            id="autoSizingCheck"
                                                                            className="me-0 mb-0"
                                                                            label={`Contacted Agent ${index + 1}`}
                                                                            checked={actn.contacted_agent}
                                                                            disabled
                                                                        />
                                                                        <Form.Label className='list_date'><FontAwesomeIcon icon={faCalendarDays} /> {actn?.contacted_agent_date || ''}</Form.Label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                    ))}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </>
                            ))}


                        </div>
                        <div>

                        </div>

                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"service_recovery"}
                            attachable_id={selectedRowData.service_recovery_id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails('', selectedRowData.service_recovery_id)}
                            attachment_no={`${selectedRowData.master_airway_bill_prefix} - ${selectedRowData.master_airway_bill_no}`}
                        />
                        <ActivityComments
                            commentable_type={"service_recovery"}
                            commentable_id={selectedRowData.service_recovery_id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails('', selectedRowData.service_recovery_id)}
                        />
                    </div>
                )}
            </div>
            {/* </div>
                        </div>
                    </div>
                </div> */}
            <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Selected {gridSelect.length > 1 ? "Airway Bill's" : 'Airway Bill'} will move to {activeTab == 'Active' || activeTab === 'Damaged' ? 'Archive' : 'Active'}</h3>
                    <p>Are you sure you want to move {gridSelect.length > 1 ? "Airway Bill's" : 'Airway Bill'} to {activeTab == 'Active' || activeTab === 'Damaged' ? 'Archive' : 'Active'}?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confirmMoveToActArc}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={imgShow} onHide={handleClose} centered className="imgmodal" size='lg'>
                <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                <Modal.Body className='text-center'>
                    {/* {console.log(selectedFile)} */}
                    <img src={selectedFile} className="img-fluid" alt="Selected" />

                </Modal.Body>
            </Modal>



            {/* </div> */}
        </>
    )
}
export default ServiceRecovery;